<template>
  <b-sidebar
    id="sidebar-invoice-add-payment"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
  <!-- #default="{ hide }" -->
    <template #default="{ hide }"  v-show="isShow" >
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Add Payment
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
        />

      </div>
      <validation-observer ref="simpleRules">
      <!-- Body -->
      <b-form class="p-2">
        <h3 v-if="invdata">Payable Amount: {{ invdata.amount ? invdata.amount : null }}</h3>
          <!-- Invoice Balance -->
          <b-form-group
              label="Invoice Balance"
              label-for="invoice-balance"
          >
              <b-form-input
                  id="invoice-balance"
                  v-model="invdata.grand_total"
                  trim
              />
          </b-form-group>
          <!-- Payment Date -->
          <b-form-group
              label="Payment Date"
              label-for="payment-date"
          >
              <flat-pickr
                  v-model="invdata.paid_date"
                  class="form-control"
              />
          </b-form-group>
          <!-- Payment Note (Optional) -->
          <b-form-group
              label="Payment Note (Optional)"
              label-for="payment-note"
          >
              <b-form-textarea
                  id="payment-note"
                  v-model="invdata.payment_note"
                  rows="3"
                  trim
              />
              <div class="d-flex flex-wrap align-items-center mt-50">
                <small class="text-muted mr-50">Quick Note:</small>
                <b-badge
                  v-for="option in quickNoteOptions"
                  :key="option.label"
                  pill
                  variant="light-primary"
                  class="cursor-pointer mr-50 mb-50"
                  @click="setQuickNote(option)"
                >
                  {{ option.label }}
                </b-badge>
              </div>
          </b-form-group>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click.prevent="validationForm"
            @click="hide"
          >
            Send
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            class="mr-2"
            type="button"
            @click.prevent="saveNoteOnly(hide)"
          >
            Save Note
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="hide"
          >
            Cancel
          </b-button>
        </div>
      </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BButton, BFormSelect, BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import {ValidationObserver, ValidationProvider} from "vee-validate";
import useJwt from "@/auth/jwt/useJwt";
import {checkRes} from "@core/services/helper";
// Use toast
import Mixin from "@core/services/mixin";

export default {
     mixins: [
        Mixin
    ],
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    BBadge,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
    vSelect,
     BFormSelect,
  },
  directives: {
    Ripple,
  },
  props: ['invdata'],
  setup() {
    const payment_method = [
       {value: 1, text: 'Cash'}, {value: 2, text: 'GATEWAY'}
    ]
     return {
      payment_method,
      payment_method_value:1,
    }
  },
  data(){
 return {
      toggle: false,
      isShow:false,
      grand_total:0,
      amount:0,
      paid_date:null,
      quickNoteOptions: [
        { label: 'bKash', value: 'Paid via bKash' },
        { label: 'Nagad', value: 'Paid via Nagad' },
        { label: 'Rocket', value: 'Paid via Rocket' },
        { label: 'Bank', value: 'Paid via Bank' },
      ],
    }
  },
  watch: {
    invdata: {
      immediate: true,
      handler(value) {
        if (!value) return
        if (!value.paid_date) {
          value.paid_date = this.todayAsString()
        }
      },
    },
  },
  methods:{
  todayAsString() {
      const d = new Date()
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
    },
  setQuickNote(option) {
      if (!this.invdata) return
      this.invdata.payment_note = option && option.value ? option.value : ''
    },
  validationForm() {
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                   useJwt.invoicePaymentIsp({
                       invoice_id: this.invdata.id ?? null,
                       payment_method: this.payment_method_value ?? null,
                       paid_date: this.invdata.paid_date ?? null,
                       grand_total: this.invdata.grand_total ?? null,
                       payment_note: this.invdata.payment_note ?? null
                    }).then(response => {
                       if (checkRes(response.status) && response.data.data) {
                           this.isShow = false
                           this.$router.push({ name: 'isp-invoice-list' })
                            .catch(success => {
                                this.toastMessage('success','Invoice Payment',response)
                            })
                       }else {
                           this.$router.push({ name: 'isp-invoice-preview' }).then(() => {
                               this.toastMessage('warning','Invoice Payment',response)
                           }).catch(error => {
                               this.toastMessage('danger','Invoice Payment',response)
                           })
                       }
                    })
                }
            })
        },
    saveNoteOnly(hide) {
      if (!this.invdata || !this.invdata.id) return
      useJwt.invoicePaymentNote({
        invoice_id: this.invdata.id ?? null,
        payment_note: this.invdata.payment_note ?? null,
      }).then(response => {
        if (checkRes(response.status) && response.data.data) {
          this.isShow = false
          if (typeof hide === 'function') hide()
          this.toastMessage('success', 'Payment Note', response)
        } else {
          this.toastMessage('warning', 'Payment Note', response)
        }
      }).catch(() => {
        this.toastMessage('danger', 'Payment Note', { data: { messages: ['Request failed'] } })
      })
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
